import {
  createStore
} from 'vuex'
import api from '@/api/api'
import team from '@/api/enterprise'
import user from '@/api/user'
function handleApiResponse(response, context, mutationName, dataPath = null) {
  if (!response) return;

  if (response.status === 200) {
      const data = dataPath ? resolvePath(response, dataPath) : response.data.result;
      context.commit(mutationName, data);
  }
}

function resolvePath(obj, path) {
  return path.split('.').reduce((prev, curr) => prev ? prev[curr] : null, obj);
}

export default createStore({
  state: {
    routerParams: null,
    // 校对选项
    advancedProofreading: false,
    checkOptions: 31,
    noticeList: [],
    sessionId: '',
    socketResult: {
      docMessage: false,
      checkResult: '',
      checkId: '',
      imageResult: ''
    },
    // 高速字数
    highNumber: 0,
    currentNumber: 0,
    totalNumber: 0,
    imgUrl: require('@/assets/avatar.svg'),
    dicStatus: ['', '使用中', '可试用', '试用结束', '试用中', '待续费', '不可用'],
    errorOptions: [{
        value: "0-",
        label: "默认分类",
      },
      {
        value: "1-",
        label: "同音错误",
      },
      {
        value: "2-",
        label: "谐音错误",
      },
      {
        value: "3-",
        label: "遗漏字词",
      },
      {
        value: "4-",
        label: "冗余字词",
      },
      {
        value: "5-",
        label: "形近字词",
      },
      {
        value: "7-",
        label: "语序错误",
      },
    ],
    hintOptions: [{
        value: "8-1",
        label: "默认分类",
      },
      {
        value: "8-2",
        label: "黄赌毒类",
      },
      {
        value: "8-3",
        label: "司法政治",
      },
      {
        value: "8-4",
        label: "宗教迷信",
      },
      {
        value: "8-5",
        label: "言语辱骂",
      },
      {
        value: "8-6",
        label: "非法信息",
      },
      {
        value: "8-7",
        label: "宣传广告",
      },
    ],
    tableHeadConfig: [{
        type: 'slot',
        slotName: 'right',
        prop: 'word',
        label: '正词',
        class: 'right-word'
      },
      {
        type: 'default',
        prop: 'update_time',
        label: '最后修改时间',
        class: ''
      },
      {
        type: 'slot',
        slotName: 'handle',
        prop: '',
        label: '操作',
        class: ''
      },
    ],
    hint: {
      "8-1": "默认分类",
      "8-2": "黄赌毒类",
      "8-3": "司法政治",
      "8-4": "宗教迷信",
      "8-5": "言语辱骂",
      "8-6": "非法信息",
      "8-7": "宣传广告",
    },
    errorHint: {
      "0-": "默认分类",
      "1-": "同音错误",
      "2-": "谐音错误",
      "3-": "遗漏字词",
      "4-": "冗余字词",
      "5-": "形近字词",
      "7-": "语序错误",
    },
    userStatus: ['', '生效中', '待续费', '异常', '已发邀请', '对方拒绝', '申请加入', '拒绝加入', '', '', '', '已失效'],
    inviteInfo: [],
    inviteNum: 0,
    roleInfo: {
      admin: '管理员',
      dic_admin: '词库管理员',
      user_admin: '成员管理员',
      user: '普通成员',
      root: '超级管理员'
    },
    myRole: 'free',
    userInfo: {},
    teamInfo: {},
    myDicNum: 0,
    myDicName: '',
    myDicStatus: 1,
    dictionary_id: '',
    uid: '',
    applyNum: 0,
    mode: 1,
    rules: {
      name: [{
          required: true,
          message: "姓名不能为空",
          trigger: "click"
        },
        {
          pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5\s]{1,8}$/,
          required: true,
          message: "姓名长度在1到8位(支持中文，数字，字母和下划线)",
          trigger: "click",
        },
      ],
      phone: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        },
        {
          pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
          required: true,
          message: "手机号格式不正确",
          trigger: "blur",
        },
      ],
      pwd: [{
          required: true,
          message: "请输入密码",
          trigger: "click"
        },
        {
          min: 3,
          max: 15,
          message: "长度在 3 到 15 个字符",
          trigger: "click",
        },
      ],
      nickname: [{
          required: true,
          message: "昵称不能为空",
          trigger: "click"
        },
        {
          pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5\s]{1,8}$/,
          required: true,
          message: "昵称长度在1到8位(支持中文，数字，字母和下划线)",
          trigger: "click",
        },
      ],
      enterprise_uuid: [{
        required: true,
        message: "请输入团队ID",
        trigger: "click"
      }, ],
      // user_name: [{ required: true, message: "请输入姓名", trigger: "click" },],
      enterprise_phone: [{
          required: true,
          message: "请输入手机号",
          trigger: "click"
        },
        {
          pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
          required: true,
          message: "手机号格式gf不正确",
          trigger: "blur"
        }
      ],
      user_name: [{
        required: true,
        message: "请输入姓名",
        trigger: "blur"
      }],
      enterprise_id: [{
        required: true,
        message: "请输入团队ID",
        trigger: "blur"
      }, ],
      code: [{
          required: true,
          message: "验证码不能为空",
          trigger: "click"
        },
        {
          min: 4,
          max: 4,
          message: "长度为4位数字",
          trigger: "click",
        },
      ],

    },
    rightConfig: [{
        type: "slot",
        slotName: "right",
        prop: "word",
        label: "正词",
        class: "right-word",
      },
      {
        type: "default",
        prop: "update_time",
        label: "最后修改时间",
        class: "",
      },
      {
        type: "slot",
        slotName: "handle",
        prop: "",
        label: "操作",
        class: "",
      },
    ],
    errorConfig: [{
        type: "slot",
        slotName: "error",
        prop: "word",
        label: "错词",
        class: "right-word",
      },
      {
        type: "slot",
        slotName: "advice",
        prop: "recommand",
        label: "建议修改为（可选）",
        class: "",
      },
      {
        type: "slot",
        slotName: "hint",
        prop: "hint",
        label: "提示语（可选）",
        class: "",
      },
      {
        type: "default",
        prop: "update_time",
        label: "最后修改时间",
        class: "",
      },
      {
        type: "slot",
        slotName: "handle",
        prop: "",
        label: "操作",
        class: "",
      },
    ],
    certainConfig: [{
        type: "slot",
        slotName: "certain",
        prop: "word",
        label: "敏感词",
        class: "right-word",
      },
      {
        type: "slot",
        slotName: "advice",
        prop: "recommand",
        label: "建议修改为（可选）",
        class: "",
      },
      {
        type: "slot",
        slotName: "hint",
        prop: "hint",
        label: "提示语（可选）",
        class: "",
      },
      {
        type: "default",
        prop: "update_time",
        label: "最后修改时间",
        class: "",
      },
      {
        type: "slot",
        slotName: "handle",
        prop: "",
        label: "操作",
        class: "",
      },
    ],
    keyWordsConfig: [{
        type: 'slot',
        slotName: 'key',
        prop: 'word',
        label: '重点词',
        class: 'right-word'
      },
      {
        type: 'default',
        prop: 'update_time',
        label: '最后修改时间',
        class: ''
      },
      {
        type: 'slot',
        slotName: 'handle',
        prop: '',
        label: '操作',
        class: ''
      },
    ],
    categoryMapping: {
      '4': '[自定义敏感词]',
      '5': '[自定义错词]',
      '6': '[共享词库敏感词]',
      '7': '[共享词库错词]'
    },
    tipMapping: {
      "1-1": ["同音错误，建议替换", 1],
      "1-": ["同音错误，建议替换", 1],
      "2-": ['常见谐音错误，建议替换', 1],
      "2-1": ['常见谐音错误，建议替换', 1],
      "2": ['常见谐音错误，建议替换', 1],
      "3-1": ['遗漏字词错误，建议补充', 3],
      "3": ['遗漏字词错误，建议补充', 3],
      "4-": ['冗余字词错误，建议删减', 2],
      "4-1": ['冗余字词错误，建议删减', 2],
      "4": ['冗余字词错误，建议删减', 2],
      "5-3": ["形近字错误，建议修改", 1],
      "6": ["易混淆词，建议检查", 3],
      "5": ["其他谐音、近形错误，建议替换", 1],
      "7": ["语序错误，建议调整语序", 3],
      "8-1": ["一般敏感词，建议修改", 3],
      "8-2": ["黄赌毒类词汇，建议修改", 3],
      "8-3": ["司法、政治词汇，建议修改", 3],
      "8-4": ["宗教、迷信词汇，建议修改"],
      "8-5": ["言语辱骂，建议修改"],
      "8-6": ["非法信息，建议修改"],
      "8-7": ["宣传、广告，建议修改"],
      "8-8": ["反动词汇，建议修改"],
      "8-9": ["民生词汇，建议修改"],
      "8-10": ["辱骂词汇，建议修改"],
      "8-11": ["贪腐词汇，建议修改"],
      "8-12": ["违法违规，建议修改"],
      "9-1": ["地址归属地错误，建议修改"],
      "9-2": ["日期不合规，建议检查修改"],
      "10-1": ["中英类型错用，建议检查"],
      "10-2": ["成对标点缺失或用反，建议检查"],
      "10-3": ["多余标点，建议删除"],
      "10-4": ["标点错用，建议修改"],
      "11-1": ["来自重点词校对，建议检查"],
      "12-1": ["来自高级校对，建议新增"],
      "12-2": ["来自高级校对，建议删除", 2],
      "12-3": ["来自高级校对，建议修改"],
    },
    specialTypeMap: {
      '4-1': '建议删除',
      '3-1': '建议补充字词',
      '6-': '混淆词',
      '7-1': '建议调整语序',
      '10-1': '中英类型错用',
      '10-2': '成对标点',
      '10-3': '标点符号连用',
      '9-2': '日期格式',
      '9-1': '地名从属关系',
      '12-2': '建议删除'
    },
    typeMap: {
      3: '敏感词',
      4: '自定义敏感词',
      5: '自定义错词',
      6: '共享词库敏感词',
      7: '共享词库错词',
      9: '自定义重点词',
      10: '共享词库重点词',
      11: '高级校对',
    }
  },
  getters: {},
  mutations: {
    tableHeadConfig(state, val) {
      state.tableHeadConfig = val
    },
    updataUID(state, val) {
      state.uid = val
    },
    GETINVITEINFO(state, val) {
      state.inviteInfo = val.data
      state.inviteNum = val.data.length || 0
    },
    SETIMGURL(state, val) {
      state.imgUrl = val
    },
    // 角色信息
    updateROLE(state, val) {
      state.myRole = val || 'free'
    },
    SetTeamInfo(state, val) {
      state.teamInfo = val
    },
    updateUserInfo(state, val) {
      state.userInfo = val
      state.myRole = val.role || 'free'
      state.uid = val.uid
    },
    SETHIGHNUM(state, val) {
      state.highNumber = val
    },
    SetAdvancedNum(state, val) {
      state.currentNumber = val
    },
    SetTotalEquityNum(state, val) {
      state.totalNumber = val
    },
    SetCheckMapping(state, val) {
      state.checkMapping = val
      val.category_description.forEach(item => {
        state.tipMapping[item[0]] = [item[1], item[2]]
      });
      val.recommendation_level.forEach(item => {
        if (item[2]) {
          state.categoryMapping[item[0]] = `[${item[2]}]`
        }
      })
    },
    SetCheckOptions(state, val) {
      state.checkOptions = val
    },
    SetAdvancedProofreading(state, val) {
      state.advancedProofreading = val
    },
    SetTeamDic(state, val) {
      if (val.data) {
        state.myDicName = val.data.dic_name
        state.myDicStatus = val.data.dic_status
        // state.myDic.dic_name = val.data.data.dic_name
        if (val.data.dic_name) {
          state.myDicNum = 1
          // state.myDic.num = 1
        } else {
          state.myDicNum = 0
          // state.myDic.num = 0
        }
      }
    },
    SetSelfDicId(state, val) {
      state.dictionary_id = val
    },
    SetApplyNum(state, val) {
      state.applyNum = val || 0
    },
    SetSocket(state, val) {
      state.socketResult[val.method] = val.value
    },
    SetSessionId(state, val) {
      state.sessionId = val
    },
    SetNotice(state, val) {
      state.noticeList = val
    }
  },
  actions: {
    getInviteInfo(context) {
      team.getTeamInviteInfo().then(res => handleApiResponse(res, context, 'GETINVITEINFO'));
    },
    getHighSpeedNumber(context) {
      api.getHighSpeedNumber().then(res => handleApiResponse(res, context, 'SETHIGHNUM', 'data.data'));
    },
    getImage(context) {
      user.getAvatar(this.state.userInfo.avatar).then(res => {
        console.log(res)
        if (res && res.data?.byteLength !== 0) {
          const blob = new Blob([res.data]);
          context.commit('SETIMGURL', window.URL.createObjectURL(blob));
        } else {
          context.commit('SETIMGURL', require('@/assets/avatar.svg'));
        }
      });
    },
    getUserInfo(context) {
      api.getUserInfo().then(res => handleApiResponse(res, context, 'updateUserInfo'));
    },
    getTeamInfo(context) {
      team.getTeamInfo().then(res => handleApiResponse(res, context, 'SetTeamInfo', 'data.data'));
    },
    getMyPublicDic(context) {
      team.getEnterpriseDic().then(res => handleApiResponse(res, context, 'SetTeamDic'));
    },
    getMySelfDic(context) {
      team.getEnterpriseSelfDic().then(res => handleApiResponse(res, context, 'SetSelfDicId', 'data.data.dicList.0.share_code'));
    },
    getEnterpriseApplyInfo(context) {
      team.getEnterpriseApplyInfo().then(res => handleApiResponse(res, context, 'SetApplyNum', 'data.data.result.result'));
    },
    getAdvancedNumber(context, query) {
      api.getUserEquity(query).then(res => {
        if (res && res.data?.code === 200) {
          context.commit('SetTotalEquityNum', Number(res.data.data.total_equity));
          context.commit('SetAdvancedNum', Number(res.data.data.current_remaining_equity));
        }
      });
    },
    getCheckMapping(context) {
      api.getCheckResultsMap().then(res => handleApiResponse(res, context, 'SetCheckMapping', 'data.data'))
    }
  },
  modules: {}
})